// @ts-nocheck

import * as R from 'ramda';
import NotificationActions from '../actions/NotificationActions';
import {
  ADD_EXPORT_WHITELIST,
  CREATE_OLD_SUBSCRIPTION,
  CREATE_SUBSCRIPTION,
  GET_ACCOUNT_BALANCE,
  GET_EXPORT_WHITELIST,
  GET_MONTH_TO_DATE_MAU,
  MAU,
  REMOVE_EXPORT_WHITELIST,
  REMOVE_SUBSCRIPTION,
  SAVE_BILL_TO_CONTACT,
  SET_PRODUCT_NAME,
  SUBSCRIPTIONS,
  UPDATE_SUBSCRIPTION_TIER,
} from '../actions/SubscriptionActions';
import { reducerWrapper } from '../support/utils';
import type { SubscriptionReducer } from '../types/subscriptionTypes';

function updateSubscriptions(state, data) {
  return R.map((v) => {
    if (v.sku !== data.sku) {
      return v;
    }

    return Object.assign({}, v, data);
  }, state);
}

export var INIT_STATE: SubscriptionReducer = {
  loading: false,
  error: null,
  data: [],
  mau: null,
  isAppInExportWhitelist: false,
  productNameEdited: null,
  monthToDateMau: null,
  billToContact: null,
  balance: null,
};
export type Action = {
  type: string;
  data: Record<string, any>;
};

function Handler(state: SubscriptionReducer, action: Action): SubscriptionReducer {
  const { data } = action;

  switch (action.type) {
    case SET_PRODUCT_NAME:
      return Object.assign({}, state, {
        productNameEdited: action.data.productName,
      });

    case MAU.response:
      return Object.assign({}, state, {
        loading: false,
        mau: Number(data.mau),
      });

    case GET_MONTH_TO_DATE_MAU.response:
      return Object.assign({}, state, {
        loading: false,
        monthToDateMau: data,
      });

    case GET_EXPORT_WHITELIST.response:
      // INTENG-16815 always set boolean data type for isAppInExportWhitelist
      const enable = typeof data.enable === 'boolean' ? data.enable : data.enable === 'true';
      return Object.assign({}, state, {
        loading: false,
        isAppInExportWhitelist: enable,
      });

    case ADD_EXPORT_WHITELIST.response:
      return Object.assign({}, state, {
        loading: false,
        isAppInExportWhitelist: data.enable,
      });

    case REMOVE_EXPORT_WHITELIST.response:
      return Object.assign({}, state, {
        loading: false,
        isAppInExportWhitelist: data.enable,
      });

    case SUBSCRIPTIONS.response:
      return Object.assign({}, state, {
        loading: false,
        data,
      });

    case CREATE_SUBSCRIPTION.response:
      if (state.productNameEdited) {
        NotificationActions.showNotification(`You successfully added ${state.productNameEdited}.`, 'success');
      }

      return Object.assign({}, state, {
        loading: false,
        data,
        productNameEdited: null,
      });

    // TODO: Remove this once we disable DI1
    case CREATE_OLD_SUBSCRIPTION.response:
      NotificationActions.showNotification(`You successfully added ${data.name}.`, 'success');
      return Object.assign({}, state, {
        loading: false,
        data: updateSubscriptions(state.data, data),
      });

    case REMOVE_SUBSCRIPTION.response:
      NotificationActions.showNotification(`You successfully canceled ${data.name}.`, 'success');
      return Object.assign({}, state, {
        loading: false,
        data: updateSubscriptions(state.data, data),
      });

    case SAVE_BILL_TO_CONTACT.response:
      return Object.assign({}, state, {
        loading: false,
        billToContact: data,
      });

    case UPDATE_SUBSCRIPTION_TIER.response:
      if (state.productNameEdited) {
        NotificationActions.showNotification(`You successfully updated ${state.productNameEdited}.`, 'success');
      }

      return Object.assign({}, state, {
        loading: false,
        data,
        productNameEdited: null,
      });

    case GET_ACCOUNT_BALANCE.response:
      return Object.assign({}, state, {
        balance: data.balance,
      });

    default:
      return state;
  }
}

const Subscriptions = reducerWrapper(INIT_STATE, Handler, {
  request: [
    MAU,
    GET_MONTH_TO_DATE_MAU,
    GET_EXPORT_WHITELIST,
    SUBSCRIPTIONS,
    CREATE_SUBSCRIPTION,
    CREATE_OLD_SUBSCRIPTION,
    UPDATE_SUBSCRIPTION_TIER,
    REMOVE_SUBSCRIPTION,
    SAVE_BILL_TO_CONTACT,
  ],
  error: [
    MAU,
    GET_MONTH_TO_DATE_MAU,
    GET_EXPORT_WHITELIST,
    SUBSCRIPTIONS,
    CREATE_SUBSCRIPTION,
    CREATE_OLD_SUBSCRIPTION,
    UPDATE_SUBSCRIPTION_TIER,
    REMOVE_SUBSCRIPTION,
    SAVE_BILL_TO_CONTACT,
  ],
  resetOn: ['APP_CHANGE'],
});
export default Subscriptions;
